import React from 'react';
import ReactDOM from 'react-dom/client';
import './styles/index.css';
import App from './components/App.jsx';
import { BrowserRouter } from 'react-router-dom'

const root = ReactDOM.createRoot(document.getElementById('root'));
console.log('%c      Davinchi Devs 💻     ', 'color: white; background: linear-gradient(45deg, #0f0f11, #7e7a7d); font-weight: bold; font-size: xx-large; padding: 10px; border-radius: 14px 14px 0 0; margin: 20px 0 0 0;')
console.log('%c      Contacts | tg: @vlxdxz        ', 'background: linear-gradient(45deg, #0f0f11 10%, #7e7a7d); color: white; font-weight: bold; font-size: x-large; padding: 10px; ' )
console.log('%c                2026                ', 'background: linear-gradient(45deg, #0f0f11 20%, #7e7a7d); color: white; font-weight: bold; font-size: x-large; padding: 10px; border-radius: 0 0 14px 14px' )
console.log('%c   Не вводите сюда ничего!  ', 'margin-top: 20px; color: black; background-color: red; font-weight: bold; font-size: xx-large; padding: 10px; border-radius: 14px 14px 0 0')
console.log('%c  Если ВАС просят что-то ввести сюда, скорее  ', 'color: black; background-color: rgb(253, 68, 68); font-weight: bold; font-size: large; padding: 10px;')
console.log('%c всего, ВАС хотят ВЗЛОМАТЬ или получить ВАШИ  ', 'color: black; background-color: rgb(253, 68, 68); font-weight: bold; font-size: large; padding: 10px;')
console.log('%c                   ДАННЫЕ                     ', 'color: black; background-color: rgb(253, 68, 68); font-weight: bold; font-size: large; padding: 10px; border-radius: 0 0 14px 14px')

root.render(
  <BrowserRouter>
    <App />
  </BrowserRouter>
);

